'use client';
import { createContext } from "react";
export const AppRootContext = createContext({
    isRendered: false
});

//# sourceMappingURL=AppRootContext.js.map